import { useContext, useEffect, useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import UserContext from "../../../navigation/context/userContext";
import { GetEventByID } from "../../../controllers/customer/EventosController";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import Review from "../../../components/review";
import QUDProgress from "../../../components/progress";
import { imagesURL } from "../../../apiRoutes/apiBase";

export default function EventsReview(){
    const { userData } = useContext(UserContext);
    const [event,setEvent] = useState([]);
    const [openReview,setOpenReview] = useState(false);
    const [isLoading,setIsLoading] = useState(false);

    const { id } = useParams();
    
    const history = useHistory();

    const redireccionar = (route) => {
        history.push(route)
    }
    

    useEffect(()=>{
        localStorage.setItem('openModalReviewEvent',true)
        handleGetEvent();
        handleReviewLocalStorage();
        /*if(userData.user !== undefined)
        {
            setName(userData.entity.name);
            setLastName(userData.entity.last_name);
            setDocumentType(userData.entity.document_type);
            setDocument(userData.entity.document_number);
            setPrefix(userData.user.prefijo);
            setPhoneNumber(userData.entity.phone);
            setEmail(userData.user.email);
        }*/
        window.scrollTo(0,0);
    },[]);

    const handleGetEvent = async () => {
        setIsLoading(true);
        let response = await GetEventByID(id);
        if(response.success === true)
        {
            setEvent(response.data.event);
            //setTickets(response.data.tickets);
            //handleSettingTickets(response.data.tickets);
        }
        setIsLoading(false);
    }

    const handleReviewLocalStorage = () => {
        if(localStorage.getItem('openModalReviewEvent') === 'true')
            setOpenReview(true)
    }

    const handleCloseReview = () => {
        localStorage.removeItem('openModalReviewEvent')
        setOpenReview(false);
        redireccionar(`/eventos/${id}`)
    }

    return(
        <Container maxWidth='lg'>
            <QUDProgress open={isLoading}/>
            <Box sx={{minHeight:'95vh'}}></Box>
            {
                event.length !== 0 &&
                <Review
                    type='event'
                    toUUID={event.uuid}
                    open={openReview}
                    //image={`${imagesURL}/eventos/${event.imagen}`}
                    name={event.nombre}
                    handleClose={()=>handleCloseReview()}
                />
            }
        </Container>
    )
}

/**
 * <Review
                 type='merchant'
                 toUUID={user.uuid}
                 name={user.apellido}
                 image={imagesURL+'empresas/'+user.imagen2}
                 open={openReview}
                 handleClose={()=>handleCloseReview()}
             />
 */